import React from "react";

// Components
import OutsideLink from "./outside-link";

// Assets
import { FaTwitter, FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";

export default function SocialIcons({ size = 18 }) {
  return (
    <div className="flex flex-row items-center justify-center py-2 md:py-0 lg:px-4 pr-4">
      <OutsideLink icon={<FaFacebookF size={size} />} route="https://www.facebook.com/unimelve/" />
      <OutsideLink icon={<FaInstagram size={size} />} route="https://www.instagram.com/unimelve/" />
      <OutsideLink icon={<FaTwitter size={size} />} route="https://twitter.com/unimelvenezuela" />
      <OutsideLink icon={<FaYoutube size={size} />} route="https://www.youtube.com/channel/UCtGSCpjpRxP86ysErp1zhow" />
    </div>
  );
}